import { connect } from 'react-redux';
import AppLoading from './AppLoading';

const mapStateToProps = (state) => ({
  appLoading: state.meta.appLoading,
});

export default connect(mapStateToProps, null)(AppLoading);
